export enum AppSeason {
  Fall = 'fall',
  Winter = 'winter',
  Spring = 'spring',
  Summer = 'summer',
}
